<template>
  <SearchBox
    ref="searchbox"
    :label="computedLabel"
    :placeholder="placeholder"
    :funcao-buscar="funcaoBuscar"
    :parametros="parametros"
    :incluir="incluir"
    :alterar="alterar"
    :tipo="tipo"
    :disabled="disabled"
    :multiline="multiline"
    @buscado="$emit('buscado', $event)"
    @selected="handleSelected"
    @botaoInclusao="$emit('botaoInclusao')"
    @botaoAlteracao="$emit('botaoAlteracao')"
  />
</template>

<script>
import SearchBox from './SearchBox.vue';

export default {
  name: 'SearchBoxDefault',
  components: { SearchBox },
  props: {
    value: { type: [String, Number], default: '' },
    modelValue: { type: [String, Number], default: '' },
    placeholder: { type: String, default: '' },
    funcaoBuscar: { type: String, required: true },
    parametros: { type: Object, default: () => ({}) },
    label: { type: String, default: '' },
    hidelabel: { type: Boolean, default: false },
    incluir: { type: Boolean, default: false },
    alterar: { type: Boolean, default: false },
    tipo: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    multiline: { type: Boolean, default: false }
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    computedLabel() {
      return this.hidelabel ? '' : this.label;
    }
  },
  methods: {
    handleSelected(item = {}) {
      const id = item && item.ID ? item.ID : '';
      const descricao = item && item.DESCRICAO ? item.DESCRICAO : '';

      this.item = item || {};
      this.$emit('input', id);
      this.$emit('update:modelValue', id);
      this.$emit('descricao', descricao);
      this.$emit('change', this.item);
    },
    selecionar(item) {
      this.item = item || {};
      this.$refs.searchbox.selecionarItemExterno(this.item);
    },
    apagar() {
      this.$refs.searchbox.apagar(true);
    },
    obterItem() {
      return this.item;
    },
    realizarBusca() {
      this.$refs.searchbox.pressEnter();
    },
    setFocus() {
      this.$refs.searchbox.setFocus();
    },
    retornaValorDigitado() {
      return this.$refs.searchbox.value;
    },
    inserirBusca(termo) {
      this.$refs.searchbox.alteracao(termo);
    }
  }
};
</script>
